import { useState } from 'react';
import { fbAuth } from '@/constants/endpoints';
import { toast } from 'sonner';

import { APIClient } from '@/lib/ApiClient';

const apiClient = new APIClient();

export const useInstagramConnection = () => {
  const [loading, setLoading] = useState(false);

  const connectInstagram = async () => {
    setLoading(true);

    try {
      const response = await apiClient.get(fbAuth, null, true);
      if (response.redirect_url) {
        window.location.href = response.redirect_url;
      } else {
        toast.error('Failed to get Instagram connection URL');
        setLoading(false);
      }
    } catch (error) {
      console.error('Instagram connection error:', error);
      toast.error('Failed to connect Instagram. Please try again.');
      setLoading(false);
    }
  };

  return { connectInstagram, loading };
};
